import React from 'react';
import { CheckCircle2, X } from 'lucide-react';

const gbp = (v) => `£${Number(v || 0).toFixed(2)}`;

export function ApplyResultPanel({ result, onClose, onExport }) {
  const written = (result.per_dest || []).flatMap(d =>
    (d.costs?.items || []).filter(i => i.write_result === 'written').map(i => ({ ...i, dest: d.dest_site_name, d: i.dest })));
  return (
    <div className="rounded-lg border border-green-300 bg-green-50 p-4 space-y-2 text-sm" data-testid="copy-apply-result">
      <div className="flex items-start justify-between">
        <p className="font-semibold text-green-800 flex items-center gap-2">
          <CheckCircle2 className="h-4 w-4" /> Applied and saved — run {result.run_id.slice(0, 8)}
        </p>
        <button onClick={onClose} className="text-green-700" data-testid="copy-apply-result-close"><X className="h-4 w-4" /></button>
      </div>
      <ul className="text-xs text-green-900 space-y-0.5">
        <li data-testid="result-assignments">Assignments added: {result.total_added}</li>
        <li data-testid="result-costs-filled">Opening costs filled: {result.total_costs_added || 0}</li>
        <li data-testid="result-costs-overwritten">Opening costs overwritten: {result.total_costs_overwritten || 0}</li>
        <li>Costed rows preserved: {result.total_costs_preserved || 0} · Unit-mismatch rows not written: {result.total_costs_blocked || 0}</li>
      </ul>
      {written.length > 0 && (
        <div className="text-xs space-y-0.5" data-testid="result-cost-readback">
          <p className="font-medium text-green-800">Read back from the destination opening stock after saving:</p>
          {written.map(w => (
            <p key={`${w.dest}-${w.product_id}`} data-testid={`result-readback-${w.product_id}`}>
              {w.dest} · {w.product_name}: {w.d.quantity} {w.d.unit_type || w.d.unit_label} — {gbp(w.d.value)} → saved {gbp(w.persisted?.value)} (qty {w.persisted?.quantity})
            </p>
          ))}
        </div>
      )}
      <button className="text-xs underline text-green-800" onClick={() => onExport(result.run_id)} data-testid="copy-apply-result-export">
        Download audit CSV
      </button>
    </div>
  );
}
